import React, { useEffect, useRef } from "react";
import { lStorage } from "utils/storage";
import { isLoginAuth, logout, setLoginData } from "utils/login";
import { useNavigate } from "react-router-dom";
import { getHomePath } from "utils/common";

import axios from "axios";
import config from "assets/config";
import { db } from "db";

function HFNAuth() {
  const navigate = useNavigate();
  const minimalParam = lStorage.get("minimalMode");
  const landingPage = lStorage.get("landingPage");
  const apiCallCount = useRef(0);

  const handleAuth = (status) => {
    document.querySelector("hfn-auth").handleProfileAuthentication(status);
  };

  const redirectPath = () => {
    let redirectTo = "";
    if (minimalParam?.authredirect)
      redirectTo = `/${minimalParam?.authredirect}`;
    else if (landingPage?.param?.pathname)
      redirectTo = `${landingPage?.param?.pathname}${landingPage?.param?.search}`;
    else redirectTo = getHomePath();
    lStorage.set("landingPage", {});
    if (isLoginAuth()) navigate(redirectTo);
    return true;
  };

  const searchFirebaseId = (firebaseIdVal) => {
    return axios
      .get(`${config.firebaseidSearchBaseUrl}/?firebase_uid=${firebaseIdVal}`)
      .then((res) => {
        const positionTypeCodes = res?.data || [];
        let positionTypeCode = "";
        if (
          positionTypeCodes &&
          positionTypeCodes.length > 0 &&
          Array.isArray(res?.data)
        ) {
          const rfPos = positionTypeCodes.find(
            (code) => code.position_type_code === "RF"
          );
          const zcPos = positionTypeCodes.find(
            (code) => code.position_type_code === "ZC"
          );
          const ccPos = positionTypeCodes.find(
            (code) => code.position_type_code === "CC"
          );
          positionTypeCode =
            rfPos?.position_type_code ||
            zcPos?.position_type_code ||
            ccPos?.position_type_code;
          return {
            positionCode: positionTypeCode,
            userPositionTypes: positionTypeCodes,
          };
        }
        return "";
      })
      .catch(() => {
        handleAuth(false);
      });
  };

  const autoLogin = async (myInfo, srcmToken) => {
    const positionCode = myInfo?.user_firebase_uid
      ? await searchFirebaseId(myInfo?.user_firebase_uid)
      : "";
    if (Object.keys(myInfo).length !== 0) {
      const user = {};
      user.name = myInfo.name;
      user.email = myInfo.user_email;
      const allData = { ...myInfo, ...positionCode };
      user.loginUser = allData;
      user.loginRole = myInfo.abhyas_stage;
      user.srcmToken = srcmToken;
      lStorage.set("authInfo", user);
      setLoginData(user);
      handleAuth(true);
      await db.appUser.clear();
      await db.appUser.put({
        userId: myInfo?.id,
        id: 1,
      });
      redirectPath();
    } else {
      handleAuth(false);
    }
  };

  const getProfile = async (accessInfo) => {
    try {
      const { getSRCMProfile } = await import("hfnauth-web/main");

      apiCallCount.current += 1;
      if (apiCallCount.current < 4) {
        const resData = await getSRCMProfile({
          srcmBaseURL: `${config.apiSRCMURI}/`,
          xClientId: `${config.xClientIdSRCM}`,
          queryParams: [
            "id",
            "name",
            "mobile",
            "phone",
            "user_email",
            "age",
            "city",
            "gender",
            "abhyas_stage",
            "user_roles",
            "user_firebase_uid",
            "srcm_group",
            "first_name",
            "last_name",
            "photo_url",
            "record_type",
          ].join(","),
        });

        if (resData?.data && resData?.data?.user_firebase_uid) {
          autoLogin(resData?.data, accessInfo?.access_token);
          handleAuth(true);
        } else {
          await getProfile(accessInfo);
          handleAuth(false);
        }
      } else {
        handleAuth(false);
      }
    } catch {
      logout();
    }
  };

  useEffect(() => {
    document.querySelector("hfn-auth").loginCallback = async (res) => {
      try {
        const accessInfo = res?.data;
        if (!accessInfo?.access_token) {
          handleAuth(false);
          return false;
        }
        localStorage.setItem("loginDateTime", new Date());
        lStorage.set("authInfo", { srcmToken: accessInfo?.access_token });
        await getProfile(accessInfo);
      } catch {
        handleAuth(false);
      }
      return true;
    };
  }, []);

  return <div />;
}

export default HFNAuth;
